import React from 'react';
import { Box, Card } from '@mui/material';
import EditableFolderKebabMenu from '../../Room/components/Edit/EditableFolderKebabMenu';
import { RenameFolderDialog } from '../../Folder/RenameFolderDialog';
import { DeleteFolderDialog } from '../../Folder/DeleteFolderDialog';
import useStyles from './useStyles';

const CARD_REST_ELEVATION = 1;

interface FolderEditableCardProps {
  children: React.ReactNode;
  displayName: string;
  isRenameDialogOpen: boolean;
  isDeleteDialogOpen: boolean;
  isDeleting: boolean;
  onRenameClick: () => void;
  onRenameClose: () => void;
  onRenameSuccess: (newName: string) => void;
  onDeleteClick: () => void;
  onDeleteClose: () => void;
  onDeleteConfirm: () => void;
}

const FolderEditableCard: React.FC<FolderEditableCardProps> = ({
  children,
  displayName,
  isRenameDialogOpen,
  isDeleteDialogOpen,
  isDeleting,
  onRenameClick,
  onRenameClose,
  onRenameSuccess,
  onDeleteClick,
  onDeleteClose,
  onDeleteConfirm,
}) => {
  const classes = useStyles();

  return (
    <>
      <Card className={classes.editCard} elevation={CARD_REST_ELEVATION}>
        <Box className={`${classes.editCardInner} folder-card`}>
          <Box flex={1}>{children}</Box>
          <Box display="flex" pr={1}>
            <EditableFolderKebabMenu
              iconButtonSize="small"
              onRename={onRenameClick}
              onDelete={onDeleteClick}
            />
          </Box>
        </Box>
      </Card>

      <RenameFolderDialog
        open={isRenameDialogOpen}
        onClose={onRenameClose}
        currentName={displayName}
        onSuccess={onRenameSuccess}
      />

      <DeleteFolderDialog
        open={isDeleteDialogOpen}
        onClose={onDeleteClose}
        onConfirm={onDeleteConfirm}
        loading={isDeleting}
      />
    </>
  );
};

export default React.memo(FolderEditableCard);
